import { uiText } from '../../../utils/uiTranslation';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ActionButton = ({ icon, label, onClick, count }) => (
  <button
    type="button"
    className="post-job-cta"
    onClick={onClick}
    style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      whiteSpace: 'nowrap'
    }}
  >
    <i className={`fa-solid ${icon}`} style={{ fontSize: 14 }}></i>
    <span>{uiText(label)}</span>
    {count > 0 && (
      <span style={{
        position: 'absolute',
        top: -6,
        right: -6,
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: '#EB4040',
        color: '#FFFFFF',
        fontSize: 11,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>{count}</span>
    )}
  </button>
);

const QuickActions = ({ employeeId, pendingPTOCount, pendingRequestsCount, handleQuickAction, isPaidThisMonth, handleMarkAsPaid }) => {
  const { t } = useTranslation('myteam');
  return (
    <div style={{
      display: 'flex',
      gap: 12,
      flexWrap: 'wrap',
      marginTop: 24,
      paddingTop: 24,
      borderTop: "1px solid var(--app-border, rgba(86, 141, 237, 0.2))"
    }}>
      {handleMarkAsPaid && !isPaidThisMonth && (
        <button
          type="button"
          className="post-job-cta"
          onClick={handleMarkAsPaid}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            whiteSpace: 'nowrap',
            borderColor: '#40EB6E',
            color: '#40EB6E'
          }}
        >
          <i className="fa-solid fa-file-invoice-dollar" style={{ fontSize: 14, color: '#40EB6E' }}></i>
          <span>{t('drawerQuickActions.markPaid', 'Mark as Paid')}</span>
        </button>
      )}

      <ActionButton icon="fa-envelope" label={t('drawerQuickActions.sendEmail', 'Send Email')} onClick={() => handleQuickAction('email')} />
      <ActionButton icon="fa-calendar-plus" label={t('drawerQuickActions.scheduleReview', 'Schedule Review')} onClick={() => handleQuickAction('schedule-review')} />
      <ActionButton icon="fa-check-circle" label={t('drawerQuickActions.approvePto', 'Approve PTO')} onClick={() => handleQuickAction('approve-pto')} count={pendingPTOCount} />
      <ActionButton icon="fa-clipboard-check" label={t('drawerQuickActions.reviewRequests', 'Review Requests')} onClick={() => handleQuickAction('review-requests')} count={pendingRequestsCount} />
      <ActionButton icon="fa-dollar-sign" label={t('drawerQuickActions.editComp', 'Edit Compensation')} onClick={() => handleQuickAction('edit-comp')} />
      <ActionButton icon="fa-sack-dollar" label={t('drawerQuickActions.addBonus', 'Add Bonus')} onClick={() => handleQuickAction('add-bonus')} />
      <ActionButton icon="fa-user-slash" label={t('drawerQuickActions.offboard', 'Offboard')} onClick={() => handleQuickAction('offboard')} />
      <ActionButton icon="fa-upload" label={t('drawerQuickActions.upload', 'Upload Document')} onClick={() => handleQuickAction('upload-doc')} />
    </div>
  );
};

export default QuickActions;
